const addonButtons = document.querySelectorAll('[data-js-billetten-addons]');

if (addonButtons.length > 0) {
    window.addEventListener('init.basm', () => {
        addonButtons.forEach((button) => {
            window.basm.getEventShowsWithProducts(button.dataset.event_no, (shows) => {
                button.disabled = !Array.isArray(shows) || shows.length === 0;
            });
        });
    });
}
